var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16235",
    "data-name": "Rectangle 16235",
    width: 20,
    height: 20,
    transform: "translate(21 541)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15",
    "data-name": "Mask Group 15",
    transform: "translate(-21 -541)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "direct",
    d: "M15.319.027.355,4.917a.516.516,0,0,0-.1.937L5.911,9.142a.516.516,0,0,0,.567-.032l1.59-1.181L6.887,9.519a.516.516,0,0,0-.032.567l3.288,5.655a.516.516,0,0,0,.937-.1L15.97.678a.516.516,0,0,0-.651-.651Zm-4.862,14.2L7.918,9.861,10.979,5.74a.516.516,0,0,0-.722-.722L6.136,8.079,1.77,5.54l12.9-4.216ZM5.418,11.309,1.992,14.735a.516.516,0,0,1-.73-.73l3.426-3.426a.516.516,0,0,1,.73.73Zm-4.526.13a.516.516,0,0,1,0-.73L2.243,9.357a.516.516,0,1,1,.73.73L1.621,11.439a.516.516,0,0,1-.73,0ZM6.64,13.024a.516.516,0,0,1,0,.73L5.288,15.105a.516.516,0,1,1-.73-.73L5.91,13.024a.516.516,0,0,1,.73,0Z",
    transform: "translate(23.5 543.499)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fc2428f2706db6019ba535e1769579c7.svg";
export { ForwardRef as ReactComponent };